import { CircleCheck } from "lucide-react";
export default function OutboundCommunicationDetails() {
  const communicationTypes = ["Water Conservation Systems", "Organic Soil Enrichment", "Zero-Waste Floral Packaging", "Seasonal Crop Rotation", "Natural Pest Management", "On-Site Composting Program"];
  const benefits = ["Preserve Local Ecosystem Health", "Enhance Bloom Longevity Naturally", "Reduce Carbon Footprint Daily", "Support Pollinator Populations", "Eliminate Synthetic Chemicals", "Cultivate a Greener Future"];
  return <section data-section-id="261798" id="sustainable-practices" className="dark bg-background py-20 md:py-28 font-default text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-4 tracking-tight">
            Sustainable Practices
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Our commitment to the earth is as deep as our roots, ensuring every bloom is grown in harmony with nature.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto">
          {}
          <div className="bg-card p-8 md:p-10 rounded-md shadow-md border border-border/30 backdrop-blur-sm">
            <h3 className="text-2xl font-default font-bold mb-8 text-foreground border-b border-border/30 pb-4">
              Cultivation Methods
            </h3>
            <ul className="space-y-5">
              {communicationTypes.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5 opacity-80" />
                  <span className="text-base md:text-lg text-card-foreground leading-tight font-default">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="bg-card p-8 md:p-10 rounded-md shadow-md border border-border/30 backdrop-blur-sm">
            <h3 className="text-2xl font-default font-bold mb-8 text-foreground border-b border-border/30 pb-4">
              Environmental Impact
            </h3>
            <ul className="space-y-5">
              {benefits.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5 opacity-80" />
                  <span className="text-base md:text-lg text-card-foreground leading-tight font-default">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}